const PrivilegesResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'privileges/',
        apiRequestParams.defaults(),
        {
            query: {
                isArray: true,
                method: 'GET',
            },
        }
    );
};

module.exports = PrivilegesResource;
